import type { FeeReportStudentRow } from '@/services/fees.api';
import { fmtMoney } from './feeFormat';

/** Shared by the Fee Report and Noorani Fee Report pages' row-level Print button. */
export function printStudentRow(row: FeeReportStudentRow, title = 'Fee Summary') {
  const html = `<!doctype html><html><head><meta charset="utf-8"/><title>${title} — ${row.studentName}</title>
    <style>
      body { font-family: 'Segoe UI', Arial, sans-serif; color: #1e293b; padding: 24px; }
      h1 { font-size: 18px; margin: 0 0 4px; }
      .meta { color: #64748b; font-size: 13px; margin-bottom: 16px; }
      table { width: 100%; border-collapse: collapse; }
      th, td { border: 1px solid #cbd5e1; padding: 8px 12px; text-align: left; }
      th { background: #f1f5f9; }
    </style>
    <script>window.onload = function(){ window.print(); };</script>
    </head><body>
    <h1>${title}</h1>
    <div class="meta">${row.studentName} · Adm# ${row.admissionNo} · ${row.className} - ${row.sectionName}</div>
    <table>
      <tr><th>Total Demanded</th><td>${fmtMoney(row.demanded)}</td></tr>
      <tr><th>Collected</th><td>${fmtMoney(row.paid)}</td></tr>
      <tr><th>Pending</th><td>${fmtMoney(row.pending)}</td></tr>
      <tr><th>Status</th><td>${row.pending <= 0 ? 'Paid' : 'Unpaid'}</td></tr>
    </table>
    </body></html>`;
  const w = window.open('', '_blank', 'width=600,height=500');
  if (!w) return;
  w.document.open();
  w.document.write(html);
  w.document.close();
}
